import MessageIcon from '@material-ui/icons/Message';
import InboxIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PeopleIcon from '@material-ui/icons/People';


export const sidebarItems = [
    {
        icon: <MessageIcon/>,
        text:"Threads"
    },
    {
        icon: <InboxIcon/>,
        text:"All DM's"
    },
    {
        icon: <DraftsIcon/>,
        text:"Mentions & Reactions"
    },
    {
        icon: <BookmarkBorderIcon/>,
        text:"Saved Items"
    },  
    {
        icon: <PeopleIcon/>,
        text:"People & Group"
    }, {
        icon: <MoreVertIcon/>,
        text:"More"
    }
    
]